import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import parse from 'html-react-parser';

const CTASection = ({ 
  title, 
  subtitle,
  buttonText,
  buttonLink,
  backgroundImage,
  backgroundPosition = 'center center',
  customClass = '',
  onButtonClick
}) => {
  const gradientOverlay = 'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6))';
  
  const backgroundImageStyles = backgroundImage ? {
    backgroundImage: `${gradientOverlay}, url(${backgroundImage})`,
    backgroundPosition: backgroundPosition,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat'
  } : {};

  const handleButtonClick = (e) => {
    if (onButtonClick) {
      e.preventDefault();
      onButtonClick();
    }
  };

  const sectionClassName = clsx(
    'w-[95%] mx-auto rounded-xl py-20 my-16 md:my-16 px-4',
    backgroundImage ? 'text-white' : 'bg-blue-600 text-white',
    customClass
  );

  const titleClassName = clsx(
    'text-3xl md:text-4xl lg:text-5xl',
    'font-bold mb-6'
  );

  const subtitleClassName = clsx(
    'text-lg md:text-xl mb-8 opacity-90'
  );

  const buttonBaseClassName = clsx(
    'bg-green-500 hover:bg-green-600',
    'text-white font-semibold',
    'py-4 px-8 rounded-lg text-lg',
    'transition-colors duration-200 shadow-lg'
  );

  const linkClassName = clsx(
    buttonBaseClassName,
    'inline-block'
  );

  return (
    <section 
      className={sectionClassName}
      style={backgroundImageStyles}
    >
      <div className="max-w-4xl mx-auto text-center">
        <h2 className={titleClassName}>
          {parse(title)}
        </h2>
        
        {subtitle && (
          <p className={subtitleClassName}>
            {parse(subtitle)}
          </p>
        )}
        
        {buttonText && (
          <div className="flex justify-center">
            {onButtonClick ? (
              <button
                onClick={handleButtonClick}
                className={buttonBaseClassName}
              >
                {parse(buttonText)}
              </button>
            ) : (
              <a
                href={buttonLink || '#'}
                className={linkClassName}
              >
                {parse(buttonText)}
              </a>
            )}
          </div>
        )}
      </div>
    </section>
  );
};

CTASection.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  buttonText: PropTypes.string,
  buttonLink: PropTypes.string,
  backgroundImage: PropTypes.string,
  backgroundPosition: PropTypes.string,
  customClass: PropTypes.string,
  onButtonClick: PropTypes.func
};

export default CTASection;